const initialState = {
    productGroups: [],
    pagination: {
        totalItems: 0,
        totalPages: 1,
        currentPage: 1,
        pageSize: 10
    },
    loading: false,
    error: null
};

const productGroupReducers = (state = initialState, action) => {
    switch (action.type) {
        case "SET_PRODUCT_GROUPS_LOADING":
            return {
                ...state,
                loading: action.payload
            };
        case "SET_PRODUCT_GROUPS": {
            const rawData = action.payload?.data;
            const groupsList = Array.isArray(rawData)
                ? rawData
                : (Array.isArray(action.payload) ? action.payload : []);
            const rawTotal = (action.payload?.totalItems ?? action.payload?.total ?? groupsList.length);
            const rawPageSize = (action.payload?.pageSize ?? 10);
            const paginationInfo = action.payload?.pagination || {
                totalItems: rawTotal,
                totalPages: (action.payload?.totalPages ?? (Math.ceil(rawTotal / (rawPageSize || 10)) || 1)),
                currentPage: (action.payload?.currentPage ?? action.payload?.page ?? 1),
                pageSize: rawPageSize
            };
            return {
                ...state,
                productGroups: groupsList,
                pagination: paginationInfo,
                error: null
            };
        }
        case "SET_PRODUCT_GROUPS_ERROR":
            return {
                ...state,
                error: action.payload
            };
        default:
            return state;
    }
};

export default productGroupReducers;
